import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { ArchiveFileGroup } from '../models/archive/archive-file-group.model';

@Injectable({
  providedIn: 'root',
})
export class ArchiveFileGroupService extends RequestService<ArchiveFileGroup> {
  static PATH = '/archive/file/group';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ArchiveFileGroupService.PATH, globalService.debugUrl);
  }
}
